type AddressComponent = {
  types: string[];
  short_name: string;
};

// Keep Google's structured jurisdiction alongside coordinates; never infer it from address text.
export const addressJurisdiction = (components: AddressComponent[] = []) => ({
  countryCode: components.find((part) => part.types.includes('country'))
    ?.short_name,
  stateCode: components.find((part) =>
    part.types.includes('administrative_area_level_1')
  )?.short_name,
});
